var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_300_3390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9992 57.554C44.769 57.554 57.553 44.77 57.553 29.0001C57.553 13.2303 44.769 0.446289 28.9992 0.446289C13.2293 0.446289 0.445312 13.2303 0.445312 29.0001C0.445312 44.77 13.2293 57.554 28.9992 57.554Z",
    fill: "#FF4055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6114 28.1968C22.3362 28.1968 23.7344 26.7986 23.7344 25.0738C23.7344 23.3489 22.3362 21.9507 20.6114 21.9507C18.8865 21.9507 17.4883 23.3489 17.4883 25.0738C17.4883 26.7986 18.8865 28.1968 20.6114 28.1968Z",
    fill: "#060610"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7793 28.1968C37.5042 28.1968 38.9024 26.7986 38.9024 25.0738C38.9024 23.3489 37.5042 21.9507 35.7793 21.9507C34.0545 21.9507 32.6562 23.3489 32.6562 25.0738C32.6562 26.7986 34.0545 28.1968 35.7793 28.1968Z",
    fill: "#060610"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9985 8.03076C17.3985 8.03076 8.0293 17.4 8.0293 29C8.0293 40.6 17.3985 49.9692 28.9985 49.9692C40.5985 49.9692 49.9678 40.6 49.9678 29C49.9678 17.4 40.5985 8.03076 28.9985 8.03076ZM28.9985 47.2923C18.9155 47.2923 10.7062 39.0831 10.7062 29C10.7062 18.9169 18.9155 10.7077 28.9985 10.7077C39.0816 10.7077 47.2908 18.9169 47.2908 29C47.2908 39.0831 39.0816 47.2923 28.9985 47.2923Z",
    fill: "#060610"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9214 33.0153C32.1214 32.123 22.2168 38.1907 21.7706 38.4584C21.146 38.8153 20.9676 39.7076 21.3245 40.3322C21.5922 40.7784 22.0383 40.9568 22.4845 40.9568C22.7522 40.9568 22.9306 40.8676 23.1983 40.7784C25.8753 39.1722 33.5491 35.0676 37.5645 35.6922C38.2783 35.7814 38.9922 35.3353 39.0814 34.5322C39.1706 33.7291 38.6353 33.1045 37.9214 33.0153Z",
    fill: "#060610"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_300_3390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorModalIcon);
export default __webpack_public_path__ + "static/media/errorModalIcon.83c60fb694f5c5b54f16c66162acace5.svg";
export { ForwardRef as ReactComponent };